import { VenuePage } from "../../types/venues";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { errorHandler, throwApiError } from "../errorHandler";

export const fetchVenues = async (venueGroupId: string | undefined) => {
  if (!venueGroupId) {
    return [];
  }

  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  return await fetch(
    // `timezone` is requested so follow-up deadlines and booking dates can be
    // read in the venue's own timezone rather than the device's.
    `${environmentVars?.CORE_API_BASE_URL}/venues?limit=-1&fields=title,timezone&venue_group=${venueGroupId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: AbortSignal.timeout(30000)
    }
  )
    .then(async (response) => {
      if (response.ok) {
        const venues = ((await response.json()).payload?.pages ??
          []) as VenuePage[];

        return venues.filter((venue) => !!venue.title);
      }

      await throwApiError(response, "Error fetching venues");
    })
    .catch((error) => {
      errorHandler(error, "Error fetching venues");
      throw error;
    });
};
